import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Row } from "reactstrap";

const Pagination = ({ data, currentPage, setCurrentPage, perPageData, setPerPageData }: any) => {

    const totalResults = data?.length || 0;
    const totalPages = Math.ceil(totalResults / perPageData);

    const handleClick = (e: any, page: number) => {
        e.preventDefault();
        setCurrentPage(page);
    };

    const handlePrevPage = (e: any) => {
        e.preventDefault();
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = (e: any) => {
        e.preventDefault();
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleFirstPage = (e: any) => {
        e.preventDefault();
        setCurrentPage(1);
    };

    const handleLastPage = (e: any) => {
        e.preventDefault();
        setCurrentPage(totalPages);
    };

    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    useEffect(() => {
        if (totalPages > 0 && totalPages < currentPage) {
            setCurrentPage(totalPages);
        }
    }, [totalPages, currentPage, setCurrentPage]);

    return (
        <React.Fragment>
            <Row className="align-items-center mt-2 g-3 text-center text-sm-start mb-4">
                {/* Result Info */}
                <div className="col-sm">
                    <div className="text-muted">
                        Displaying
                        <span className="fw-semibold ms-1">
                            {Math.min(totalResults, (currentPage - 1) * perPageData + 1)} - {Math.min(totalResults, currentPage * perPageData)}
                        </span> of
                        <span className="fw-semibold"> {totalResults}</span> results
                    </div>
                </div>

                {/* Per Page Selector */}
                {setPerPageData && (
                    <div className="col-sm-auto">
                        <select
                            className="form-select form-select-sm w-auto"
                            value={perPageData}
                            onChange={(e) => {
                                setPerPageData(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            {[5, 10, 25, 50, 100].map(size => (
                                <option key={size} value={size}>{size} per page</option>
                            ))}
                        </select>
                    </div>
                )}

                {/* Pagination Controls */}
                <div className="col-sm-auto">
                    <ul className="pagination pagination-separated pagination-md justify-content-center justify-content-sm-start mb-0">
                        {/* First */}
                        <li className={currentPage <= 1 ? "page-item disabled" : "page-item"}>
                            <Link to="#!" className="page-link" onClick={handleFirstPage}>First</Link>
                        </li>

                        {/* Previous */}
                        <li className={currentPage <= 1 ? "page-item disabled" : "page-item"}>
                            <Link to="#!" className="page-link" onClick={handlePrevPage}>Previous</Link>
                        </li>

                        {/* Page Numbers */}
                        {(() => {
                            const visiblePages = 5;
                            const startPage = Math.max(1, Math.min(currentPage - Math.floor(visiblePages / 2), totalPages - visiblePages + 1));
                            const endPage = Math.min(totalPages, startPage + visiblePages - 1);

                            return pageNumbers.slice(startPage - 1, endPage).map((item) => (
                                <li key={item} className={currentPage === item ? "page-item active" : "page-item"}>
                                    <Link to="#!" className="page-link" onClick={(e) => handleClick(e, item)}>
                                        {item}
                                    </Link>
                                </li>
                            ));
                        })()}

                        {/* Next */}
                        <li className={currentPage >= totalPages ? "page-item disabled" : "page-item"}>
                            <Link to="#!" className="page-link" onClick={handleNextPage}>Next</Link>
                        </li>

                        {/* Last */}
                        <li className={currentPage >= totalPages ? "page-item disabled" : "page-item"}>
                            <Link to="#!" className="page-link" onClick={handleLastPage}>Last</Link>
                        </li>
                    </ul>
                </div>
            </Row>
        </React.Fragment>
    );
}

export default Pagination;
